module.exports = __webpack_public_path__ + "static/media/2018.abe02213.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2018.svg
// module id = 609
// module chunks = 0